import React from 'react';
import PropTypes from 'prop-types';

const NatureType = ({ data }) => {
  let displayText = "";
  switch (data){
    case 1:
      displayText = "Áfallinn";
      break;
    case 2:
      displayText = "Útlagður";
      break;
    default:
      displayText = "";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

NatureType.propTypes = {
  data: PropTypes.number,
};

export default NatureType;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Display/NatureType.js